<template>
    <section>
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container d-flex flex-column bg-blue">
                    <header class="mdc-top-app-bar position-static t-color-title bg-blue">
                        <div class="mdc-top-app-bar__row">
                            <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start">
                                <a class="material-icons mdc-top-app-bar__navigation-icon t-color-title" @click="moveParentRouter()">arrow_back</a>
                            </section>
                            <section class="mdc-top-app-bar__section title">
                                <div class="mdc-top-app-bar__title">
                                    {{$t('1021')}}
                                    <!-- 구매 정보 -->
                                </div>                
                            </section>
                            <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end">
                                <a class="material-icons mdc-top-app-bar__action-item" aria-label="search" alt="search"></a>
                            </section>
                        </div>
                    </header>

                    <section class="flex-grow-1 scroll-y">
                        <div class="round-body pdl-8 pdr-8 mgt-18">
                            <div class="round">
                                <div class="gradient-body">
                                    <div class="gradient"></div>
                                </div>
                            </div>
                        </div>
                        <div class="mgt-10 mgb-16 mgl-16 mgr-16 bg-white">
                            <div class="pdl-16 pdr-16 pdb-16">
                                <div class="t-subtitle2 pdt-16">
                                    {{$t(orderCategory)}}
                                    <!-- 구매 내역 -->
                                </div>
                                <div class="t-body1 mgt-10">
                                    {{goodsName}}
                                </div>
                                

                                <div v-if="['REQUEST_PAY', 'PAID', 'PAID_FREE'].indexOf(orderStatus) >= 0">
                                    <hr class="divider mgt-16">

                                    <div class="mgt-16 mgb-16">
                                        
                                        <div class="t-body3 t-color-gray2">
                                            {{$t('1022')}}
                                            <!-- 학습 가능 기간 -->
                                        </div>
                                        <div class="t-body1 mgt-2">
                                            {{$moment(learningStartDatetime).format('l')}} ~ {{$moment(learningEndDatetime).format('l')}}
                                        </div>
                                        
                                    </div>
                                </div>

                                <div class="mgt-16 mgb-16" v-if="['PAID'].indexOf(orderStatus) >= 0">
                                    <div class="t-body3 t-color-gray2">
                                        {{$t('1043')}}
                                        <!-- 구매 일자 -->
                                    </div>
                                    <div class="t-body1 mgt-2">
                                        {{$moment(paidDate).format('l')}}
                                    </div>
                                </div>
                                <div v-if="['REQUEST_PAY', 'PAID'].indexOf(orderStatus) >= 0">
                                    <hr class="divider mgt-16">
                                    <div class="mgt-16 mgb-16" v-if="['REQUEST_PAY'].indexOf(orderStatus) >= 0">
                                        <div class="t-body3 t-color-gray2">
                                            {{$t('1023')}}
                                            <!-- 결제할 금액 -->
                                        </div>
                                        <div class="t-body1 mgt-2">
                                            {{currency}}
                                            <span class="t-color-red1">{{$n(paymentPrice)}}</span>                                            
                                        </div>
                                    </div>

                                    <div class="mgt-16 mgb-16" v-if="['PAID'].indexOf(orderStatus) >= 0">
                                        <div class="t-body3 t-color-gray2">
                                            {{$t('1044')}}
                                            <!-- 결제 금액 -->
                                        </div>
                                        <div class="t-body1 mgt-2">
                                            {{currency}}
                                            <span class="price t-color-red1">{{$n(paymentPrice)}}</span>                                            
                                        </div>
                                    </div>
                                    
                                    

                                    <div class="mgt-16 mgb-16">
                                        <div class="t-body3 t-color-gray2">
                                            {{$t('1024')}}
                                            <!-- 상품 금액 -->
                                        </div>
                                        <div class="t-body1 mgt-2">
                                            {{currency}}
                                            <span class="t-color-red1">{{$n(totalPrice)}}</span>
                                        </div>
                                    </div>

                                    <div class="mgt-16 mgb-16">
                                        <div class="t-body3 t-color-gray2">
                                            {{$t('1025')}}
                                            <!-- 할인된 금액 -->
                                        </div>
                                        <div class="t-body1 mgt-2">
                                            {{currency}}
                                            <span class="t-color-red1">{{$n(discountPrice)}}</span>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="['REQUEST_PAY', 'PAID'].indexOf(orderStatus) >= 0">
                                    <hr class="divider mgt-16">

                                    <div class="mgt-16 mgb-16">
                                        <div class="t-body3 t-color-gray2">
                                            {{$t('1026')}}
                                            <!-- 결제 수단 -->
                                        </div>
                                        <div class="t-body1 mgt-2">
                                            {{printPaymentMethod}}
                                        </div>
                                    </div>

                                    <div class="mgt-16 mgb-16">
                                        <div class="t-body3 t-color-gray2">
                                            {{$t('1027')}}
                                            <!-- 결제 상태 -->
                                        </div>
                                        <div class="t-body1 mgt-2">
                                            <!-- {{orderStatusTranslate}} -->
                                            {{$t(orderStatusTranslate)}}
                                        </div>
                                    </div>
                                </div>
                                
                                
                                <div v-if="['REQUEST_PAY'].indexOf(orderStatus) >= 0">
                                    <hr class="divider mgt-16">
                                    <div class="mgt-16 mgb-16">
                                        <div class="t-body1 mgt-2">
                                            {{$t('1028')}}<br>
                                            {{$t('1029')}}
                                        </div>
                                    </div>

                                    <div class="mgt-16 mgb-16">
                                        <div class="t-body3 t-color-gray2">
                                            {{$t('1030')}}
                                            <!-- 입금 계좌 -->
                                        </div>
                                        <div class="t-body1 mgt-2">
                                            {{bankName}} 
                                            {{bankNumber}}
                                        </div>
                                    </div>

                                    <div class="mgt-16 mgb-16">
                                        <div class="t-body3 t-color-gray2">
                                            {{$t('1031')}}
                                            <!-- 예금주 -->
                                        </div>
                                        <div class="t-body1 mgt-2">
                                            {{bankDepositName}} 
                                        </div>
                                    </div>

                                    <div class="mgt-16 mgb-16">
                                        <div class="t-body3 t-color-gray2">
                                            {{$t('1032')}}
                                            <!-- 입금액 -->
                                        </div>
                                        <div class="t-body1 mgt-2">
                                            {{currency}}
                                            <span class="price t-color-red1">{{$n(paymentPrice)}}</span>
                                        </div>
                                    </div>
                                    <div class="mgt-16 mgb-16">
                                        <div class="t-body3 t-color-gray2">
                                            {{$t('1033')}}
                                            <!-- 입금 기한 -->
                                        </div>
                                        <div class="t-body1 mgt-2">
                                            {{$moment(deadline).format('lll')}}
                                        </div>
                                    </div>
                                </div>

                                <div v-if="['REQUEST_REFUND', 'REFUNDING', 'REJECT_REFUND','REFUNDED','FAIL_REFUND'].indexOf(orderStatus) >= 0">
                                    <hr class="divider mgt-16">
                                    
                                    <div class="mgt-16 mgb-16">
                                        <div class="t-body3 t-color-gray2">
                                            {{$t('1148')}}
                                            <!-- 환불 코드 -->
                                        </div>
                                        <div class="t-body1 mgt-2">
                                            {{refundCode}}
                                        </div>
                                    </div>

                                    <div class="mgt-16 mgb-16">
                                        <div class="t-body3 t-color-gray2">
                                            {{$t('1149')}}
                                            <!-- 환불 상태 -->
                                        </div>
                                        <div class="t-body1 t-color-red1">
                                            <!-- {{orderData.status.translate}} -->
                                            <!-- {{orderStatusTranslate}} -->
                                            {{$t(orderStatusTranslate)}}
                                            
                                        </div>
                                    </div>

                                    <div class="mgt-16 mgb-16">
                                        <div class="t-body3 t-color-gray2">
                                            {{$t('1150')}}
                                            <!-- 환불 요청 사유 -->
                                        </div>
                                        <div class="t-body1 mgt-2">
                                            {{refundRequestReason}}
                                        </div>
                                    </div>

                                    <div class="mgt-16 mgb-16">
                                        <div class="t-body3 t-color-gray2">
                                            {{$t('1151')}}
                                            <!-- 환불 금액 입금 계좌 -->
                                        </div>
                                        <div class="t-body1 refund-account">
                                            <span>
                                                {{refundAccount.bank.text}}
                                            </span>
                                            <span>
                                                {{refundAccount.number}}
                                            </span>
                                            <span>
                                                {{refundAccount.name}}
                                            </span>
                                            
                                            
                                        </div>
                                    </div>

                                    <div class="mgt-16 mgb-16">
                                        <div class="t-body3 t-color-gray2">
                                            {{$t('1152')}}
                                            <!-- 환불 요청일 -->
                                        </div>
                                        <div class="t-body1 mgt-2">
                                            {{$moment(refundRequest).format('lll')}}
                                        </div>
                                    </div>
                                    <div v-if="['REQUEST_REFUND'].indexOf(orderStatus) >= 0">
                                        <hr class="divider mgt-16">
                                        <div class="mgt-16 mgb-16">
                                            <div class="t-body3 t-color-gray2">
                                                {{$t('1153')}}
                                                <!-- 결제 금액 -->
                                            </div>
                                            <div class="t-body1 mgt-2">
                                                {{currency}}
                                                <span class="t-color-red1">{{$n(paymentPrice)}}</span>   
                                            </div>
                                        </div>
                                    </div>

                                    <div v-if="['REFUNDED'].indexOf(orderStatus) >= 0">
                                        <hr class="divider mgt-16">
                                        <div class="mgt-16 mgb-16">
                                            <div class="t-body3 t-color-gray2">
                                                {{$t('1172')}}
                                                <!-- 환불 금액 -->
                                            </div>
                                            <div class="t-body1 mgt-2">
                                                {{refundAmountCurrency}}
                                                <span class="t-color-red1">{{$n(refundAmountValue)}}</span>   
                                            </div>
                                        </div>

                                        <div class="mgt-16 mgb-16">
                                            <div class="t-body3 t-color-gray2">
                                                {{$t('1173')}}
                                                <!-- 환불 승인 일자 -->
                                            </div>
                                            <div class="t-body1 mgt-2">
                                                {{$moment(refundApproved).format('lll')}}
                                            </div>
                                        </div>
                                    </div>

                                    <div v-if="['REJECT_REFUND'].indexOf(orderStatus) >= 0">
                                        <hr class="divider mgt-16">
                                        <div class="mgt-16 mgb-16">
                                            <div class="t-body3 t-color-gray2">
                                                {{$t('1180')}}
                                                <!-- 환불 반려 사유 -->
                                            </div>
                                            <div class="t-body1 mgt-2">
                                                {{refundRejectReason}}
                                                
                                            </div>
                                        </div>

                                        <div class="mgt-16 mgb-16">
                                            <div class="t-body3 t-color-gray2">
                                                {{$t('1181')}}
                                                <!-- 환불 반려 일자 -->
                                            </div>
                                            <div class="t-body1 mgt-2">
                                                {{$moment(refundReject).format('lll')}}
                                            </div>
                                        </div>
                                    </div>


                                    <div v-if="['REFUNDING'].indexOf(orderStatus) >= 0">
                                        <hr class="divider mgt-16">
                                        <div class="mgt-16 mgb-16">
                                            <div class="t-body3 t-color-gray2">
                                                {{$t('1162')}}
                                                <!-- 환불 예정 금액 -->
                                            </div>
                                            <div class="t-body1 mgt-2">
                                                {{refundAmountCurrency}}
                                                <span class="price t-color-red1">{{$n(refundAmountValue)}}</span>   
                                            </div>
                                        </div>

                                        <div class="mgt-16 mgb-16">
                                            <div class="t-body3 t-color-gray2">
                                                {{$t('1163')}}
                                                <!-- 환불 승인 일자 -->
                                            </div>
                                            <div class="t-body1 mgt-2">
                                                {{$moment(refundApproved).format('lll')}}
                                            </div>
                                        </div>
                                    </div>                                        
                                </div>
                            </div>
                        </div>
                        <div class="pdr-16 pdl-16">
                            <div class="mgt-16 mgb-16" v-if="['PAID'].indexOf(orderStatus) >= 0">
                                <div class="t-subtitle2">
                                    {{$t('1122')}}
                                    <!-- 학습 중도 포기에 대한 안내 -->
                                </div>
                                <div class="t-body3 mgt-10">
                                    <span>
                                        {{$t('1123')}}<br>
                                        {{$t('1124')}}<br>
                                        {{$t('1125')}}
                                        <!-- 
                                            학습 중단을 원하는 경우, 상품 환불 요청을 할 수 있습니다.
                                            환불 요청 직후부터 해당 상품은 더이상 학습이 불가함을 알려드립니다.
                                            관리자가 환불 요청 내용을 승인 시 환불이 처리되며, 환불 금액은 관리자에 의해 책정됩니다.
                                            -->
                                    </span>
                                </div>
                            </div>

                            <div class="mgt-16 mgb-16" v-if="['PAID_FREE'].indexOf(orderStatus) >= 0">
                                <div class="t-subtitle2">
                                    {{$t('1122')}}
                                    <!-- 학습 중도 포기에 대한 안내 -->
                                </div>
                                <div class="t-body3 mgt-10">
                                    <span>
                                        {{$t('488')}}<br>
                                        {{$t('489')}}
                                        <!-- 
                                            학습 중단을 원하는 경우, 신청을 취소할 수 있습니다.
                                            신청 취소 직후부터 해당 상품은 더 이상 학습이 불가함을 알려드립니다.
                                            -->
                                    </span>
                                </div>
                            </div>

                            <div class="mgt-16 mgb-16" v-if="['REFUNDING'].indexOf(orderStatus) >= 0">
                                <div class="t-body3">
                                    <span>
                                        {{$t('1164')}}
                                        
                                        <!-- 
                                            환불이 완료되기까지 약 14일이 소요될 수 있습니다.
                                            -->
                                    </span>
                                </div>
                            </div>

                            <div class="mgt-16 mgb-16" v-if="['FAIL_REFUND'].indexOf(orderStatus) >= 0">
                                <div class="t-subtitle2">
                                    {{$t('1189')}}
                                    <!-- 환불이 승인되었으나 보류 상태입니다 -->
                                </div>
                                <div class="t-body3 mgt-10">
                                    <span>
                                        {{$t('1190')}}<br>
                                        {{$t('1191')}}
                                        <!-- 
                                            회원님의 환불 요청이 승인되었으나, 결제사의 문제로 환불 
                                            처리가 보류되었습니다.
                                            관리자가 환불 금액을 직접 송금할 계좌 정보를 입력해주세
                                            요.
                                            -->
                                    </span>
                                </div>
                            </div>
                            

                            
                            
                        </div>
                    </section>

                    <section class="pdl-16 pdr-16 pdb-20">
                        <button class="mdc-button btn-white w-full mgt-16" @click="moveQnA(paymentMethod)" v-if="['REQUEST_REFUND','REFUNDING','REJECT_REFUND','FAIL_REFUND','REFUNDED'].indexOf(orderStatus) >= 0">
                            {{$t('1154')}}
                            <!-- 1:1 문의하기 -->
                        </button>

                        <button class="mdc-button mdc-button--raised btn-red w-full mgt-16" @click="requestRefund(paymentMethod)" v-if="['PAID'].indexOf(orderStatus) >= 0">
                            {{$t('1126')}}
                            <!-- 환불 요청하기 -->
                        </button>

                        <button class="mdc-button mdc-button--raised btn-red w-full mgt-16" @click="requestRefund(paymentMethod)" v-if="['FAIL_REFUND'].indexOf(orderStatus) >= 0">
                            {{$t('1192')}}
                            <!-- 계좌 정보 입력 -->
                        </button>

                        <button class="mdc-button btn-white w-full mgt-16" @click="requestRefund(paymentMethod)"  v-if="['REQUEST_REFUND', 'REFUNDING','FAIL_REFUND'].indexOf(orderStatus) >= 0">
                            {{$t('1155')}}
                            <!-- 환불 정보 수정 -->
                        </button>

                        <button class="mdc-button mdc-button--raised btn-red w-full mgt-16" @click="cancelEnrollment()" v-if="['PAID_FREE'].indexOf(orderStatus) >= 0">
                            {{$t('490')}}
                            <!-- 등록 취소하기 -->
                        </button>
                        
                        <button class="mdc-button mdc-button--raised btn-red w-full mgt-16" @click="cancelPurchase()" v-if="['REQUEST_PAY'].indexOf(orderStatus) >= 0">
                            {{$t('1035')}}
                            <!-- 구매 취소하기 -->
                        </button>

                    </section>

                    
                </div>
            </div>
        </div>
    </section>
</template>

<script>

// CREATED_ORDER(1, "주문 생성", "code.order.list.status.created.order") : 주문생성
// REQUEST_PAY(2, "결제 요청", "code.order.list.status.request.pay") : 결제대기
// CANCEL_PAY(3, "결제 취소", "code.order.list.status.cancel.pay") : 결제취소
// PAID(4, "결제 완료", "code.order.list.status.paid") : 결제완료
// REQUEST_REFUND(5, "환불 요청", "code.order.list.status.request.refund") : 환불요청
// REFUNDING(6, "환불 처리", "code.order.list.status.refunding") : 환불처리중
// REJECT_REFUND(7, "환불 반려", "code.order.list.status.reject.refund") : 환불반려
// REFUNDED(8, "환불 완료", "code.order.list.status.refunded") : 환불완료
// FAIL_REFUND(9, "환불 보류", "code.order.list.status.fail.refund") : 환불보류
// PAID_FREE(20, "무료 결제", "code.order.list.status.paid.free") : 신청완료
// REFUNDED_FREE(21, "무료 결제 환불", "code.order.list.status.refunded.free") : 신청취소
// UNKNOWN(9999, "알수없는 상태", "code.order.list.status.unknown") : 알수 없는 상태

/**
 * 멤버십 - 구매 상세 컴포넌트(membership - purchase view component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCDialog} from '@material/dialog';

import learnApi from '@/api/learnApi.js'
import salesApi from '@/api/salesApi.js'
import {commonMixin} from '@/mixins/common.js'
export default {
    data() {
        return {
            orderId: null,
            orderCategory: '',
            goodsName: '',
            learningEndDatetime: '',
            learningStartDatetime: '',
            paymentPrice: '',
            totalPrice: '',
            discountPrice: '',
            currency: '',
            bankName: '',
            bankNumber: '',
            bankDepositName: '',
            deadline: '',
            paidDate: 0,
            learnerId: '',

            orderStatus: '',
            orderStatusTranslate: '',
            paymentMethod: '',
            depositAccount: {},

            refundDialog: null,

            bankList: [],
            refundStatus: null,

            refundAccount: '',
            refundApproved: '',
            refundCanceled: '',

            refundAmountCurrency: '',
            refundAmountValue: '',

            refundCode: '',
            refundReject: '',
            refundRejectReason: '',
            refundRequest: '',
            refundRequestReason: '',
            refundReject: '',


        }
    },

    mixins: [commonMixin],
    mounted() {
        this.orderId = this.$route.params.orderId
        this.fatchData()
        
    },

    computed: {
        isBeforeBankTransfer() {
            return this.orderStatus === 'REQUEST_PAY' && this.paymentMethod === 'bank_transfer'
        },

        isPaid() {
            return this.orderStatus === 'PAID'
        },

        isOrderFree() {
            return this.paymentMethod === 'FREE'
        },

        isRefund() {
            return !!this.refundStatus
        },

        // set payment method text
        printPaymentMethod() {
            switch (this.paymentMethod) {
                case 'paypal':
                    return 'PayPal'
                    break;
                case 'bank_transfer':
                    return 'Bank Transfer'
                    break;
                case 'dummy':
                    return 'Dummy'
                    break;
                case 'credit_card':
                    return 'Credit Card'
                    break;
                case 'FREE':
                    return 'Free'
                    break;
                default:
                    break;
            }
        }

    },

    methods: {
        fatchData() {
            let params = {
                orderId: this.$route.params.orderId
            }
            
            // get sales order information
            salesApi.salesOrderDetail(params).then((response) => {
                let orderData = response.data.data

                console.log('orderData', orderData);
                this.orderCategory = orderData.category.translate
                this.goodsName = orderData.goods.name

                this.learningEndDatetime = Number(orderData.goods.information.learningEndDatetime || orderData.goods.information.postEndDatetime)
                this.learningStartDatetime = Number(orderData.goods.information.learningStartDatetime || orderData.goods.information.postStartDatetime)

                this.deadline = Number(orderData.deadline)
                this.paymentPrice = orderData.paymentPrice
                this.totalPrice = orderData.totalPrice
                this.discountPrice = orderData.discountPrice
                this.currency = orderData.currency

                this.paidDate = orderData.paidDate
                
                this.orderStatus = orderData.status.value
                this.orderStatusTranslate = orderData.status.translate

                
                // this.orderStatus = ''
                this.paymentMethod = orderData.paymentMethod
                this.depositAccount = orderData.depositAccount
                if (orderData.paymentMethod === 'bank_transfer' && this.depositAccount) {
                    this.bankName = orderData.depositAccount.bank.text
                    this.bankNumber = orderData.depositAccount.number
                    this.bankDepositName = orderData.depositAccount.name
                }else {
                    //this.learnerId = orderData.paidData.learnerId
                }

                if (orderData.paidData) {
                    this.learnerId = orderData.paidData.learnerId
                }

                this.refundStatus = orderData.refundStatus

                this.refundAccount = orderData.refundAccount
                this.refundApproved = orderData.refundApproved
                this.refundCanceled = orderData.refundCanceled

                if (orderData.refundAmount) {
                    this.refundAmountCurrency = orderData.refundAmount.currency
                    this.refundAmountValue = orderData.refundAmount.value
                }
                

                this.refundCode = orderData.refundCode
                this.refundReject = orderData.refundReject
                this.refundRejectReason = orderData.refundRejectReason
                this.refundRequest = orderData.refundRequest
                this.refundRequestReason = orderData.refundRequestReason
                this.refundReject = orderData.refundReject


                this.$parent.setTopAppBarCustom({
                    leftBtnMode: 'arrow_back',
                    rightBtnMode: '',
                    title: this.$t('1021'), //'구매내역',
                    leftBtnMethod: () => {
                        this.$router.go(-1)
                    },
                    rightBtnMethod: '',
                })
            }).catch((err) => {

            })
            
        },

        // call refund request popup
        requestRefund(paymentMethod) {
            
            let alertData = {
                title: this.$t('1127'), //환불 요청하시겠습니까?
                content: this.$t('1128') + ' ' + this.$t('1129') , //'환불 요청 시 학습은 불가능하며, 관리자 승인 후 환불이 처리됩니다.
                accept: this.$t('1131'), //'확인',
                cancel: this.$t('1130'), //'취소'
            }
            this.$confirm(alertData).then(() => {
                this.requestPaypalRefund()
            }).catch(() => {

            })
        },

        
        // cancel enrollment
        cancelEnrollment() {
            let alertData = {
                title: this.$t('491'), //신청을 취소하시겠습니까?
                content: this.$t('492') + ' ' + this.$t('493') , //신청 취소 시 학습이 더 이상 불가능합니다. 확인을 누르면 신청이 취소됩니다.
                accept: this.$t('495'), //'확인',
                cancel: this.$t('494'), //'취소'
            }
            this.$confirm(alertData).then(() => {
                this.requestCancelEnrollment()
            }).catch(() => {

            })
        },

        // cancel purchase
        cancelPurchase() {
            let alertData = {
                title: this.$t('1036'), //구매를 취소하시겠습니까?
                content: this.$t('1037') + ' ' + this.$t('1038') , //구매 취소는 결제 대기 상태인 경우만 가능합니다. 확인을 누르면 구매가 취소됩니다.
                accept: this.$t('1040'), //'확인',
                cancel: this.$t('1039'), //'취소'
            }
            this.$confirm(alertData).then(() => {
                // this.requestPaypalRefund()
                this.requestCancelPurchase()
            }).catch(() => {

            })
        },
        
        // request cancel enrollment
        requestCancelEnrollment() {
            let params = {
                orderId: this.orderId,
            }

            salesApi.selesRequestRefund(params).then((response) => {
                this.$router.go(-1)
            })
            
        },

        // request cancel purchase
        requestCancelPurchase() {
            console.log('Todo-구매취소 API 호출');
        },


        // move request refund 
        requestPaypalRefund() {
            this.$router.push({
                name: 'MemberPurchaseRefund',
                params: {
                    orderId: this.orderId
                }
            })
        },

        moveQnA() {
            this.$router.push({
                name: 'MemberPurchaseQnA',
                params: {orderId: this.orderId}
            })
        }
    }
}
</script>